module.exports = __webpack_public_path__ + "static/media/design7.36033c25.jpg";